// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--atlS5","image":"a10a3f92e9--image--uDV5b"};